export default __webpack_public_path__ + "static/media/us.be8908f0.svg";